import React from 'react';
import bottle from '../images/bottle.png';
import icon1 from '../images/icon1.png';
import icon2 from '../images/icon2.png';
import icon3 from '../images/icon3.png';
import { Divider, Grid, Header, Image, Segment } from 'semantic-ui-react';

const Glucanosom = () => {
  return (
    <Segment raised>
      <Header as='h1' textAlign='center'>
        Glucanosom
        <Header.Subheader>
          ABAC’s trademarked Glucanosom (Swiss-quality Yeast Glucan), developed using proprietary cutting-edge isolation process yielding
        </Header.Subheader>
      </Header>

      <Divider />

      <Grid stackable padded columns={2}>
        <Grid.Column>
          <Image centered src={bottle} />
        </Grid.Column>
        
        <Grid.Column className='large-text'>
          <Image size='mini' centered src={icon1} />
          <p>All natural dietary supplement known for the highest purity (85%), beta (or β)-1,3 and beta (or β)-1,6 chain linkages, and the most bioavailable form of Yeast Glucan.</p>
          
          <Image size='mini' centered src={icon2} />
          <p>Purest natural dietary supplement form Swiss-quality yeast, insoluble whole Glucan particles distinct from other Beta Glucans on the market which are soluble derived from bacteria and mushrooms.</p>
          
          <Image size='mini' centered src={icon3} />
          <p>Glucanosom’s compelling immune response is scientifically well-established and has been confirmed by clinical studies. It’s the only yeast Glucan on the market developed using our cutting edge isolation process.</p>
        </Grid.Column>
      </Grid>
    </Segment>
  );
}

export default Glucanosom;


// WEBPACK FOOTER //
// ./src/components/Glucanosom.js